// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","container":"styles_container__2Kpbr","spinner":"styles_spinner__3Tr52"};